import React from "react";
import ClockIcon from "@/assets/icons/clock-icon.svg";
import styles from "./index.module.scss";

function MakingChangesToMyDelivery() {
  return (
    <div>
      <section>
        <img src={ClockIcon.src} alt="" className={styles.clockIcon} />
        <h2>After the order is placed, you have a short time to make changes</h2>
        <p>
          You may be able to make changes to delivery depending on the status of your order and the type of product(s).
        </p>
        <p>
          To check, sign in to <a href="https://account.johnlewis.com/orders">My Account</a> or view the order details
          from your order confirmation email. The option to change delivery will appear if it&apos;s available.
        </p>
      </section>
      <section>
        <h2>Can’t change delivery?</h2>
        <p>
          If the option doesn’t appear, unfortunately it’s too late to make changes and your order will be delivered as
          scheduled.
        </p>
        <p>
          Any unwanted items can be returned up to 30 days after purchase.{" "}
          <a href="https://www.johnlewis.com/customer-services/returns/how-do-i-return-an-item">
            Find out how to make a return
          </a>
        </p>
      </section>
    </div>
  );
}

export default MakingChangesToMyDelivery;
